<template lang="pug" src="./navigation-desktop.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  computed: {
    navScrolled () {
      return this.offsetTop >= (window.innerHeight * 0.45)
    },
    links () {
      return this.$router.options.routes.filter(item => item.navigation)
    },
    props () {
      return this.$store.state.app
    }
  },
  data () {
    return {
      offsetTop: null
    }
  },
  created () {
    window.addEventListener('scroll', () => {
      this.offsetTop = window.pageYOffset
    })
  },
  methods: {
    activate () {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false)
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// navigation-desktop.vue?41d3c436